var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mockData as documentAlerts } from '@web/lib/demo/data/documentAlert';
import { filterData, getUsers } from '@web/lib/demo/utils';
import { analyticAlertsSummary } from '@workalizer/shared/services/analyticAlertsSummary';
export var alertsSummary = function (input) {
    var _a;
    var orgUnitUserIds = input.orgUnitId
        ? getUsers({ orgUnitId: input.orgUnitId }).map(function (user) { return user.id; })
        : null;
    var filteredData = filterData(__spreadArray([], documentAlerts, true), [
        {
            key: 'createdAt',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'createdAt',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: (_a = input.triggeredBy) !== null && _a !== void 0 ? _a : 0,
            operator: 'eq',
            isSkip: !input.triggeredBy
        },
        {
            key: 'userId',
            value: orgUnitUserIds !== null && orgUnitUserIds !== void 0 ? orgUnitUserIds : [],
            operator: 'in',
            isSkip: !orgUnitUserIds
        }
    ]);
    var alertsSummary = analyticAlertsSummary(filteredData.map(function (alert) { return (__assign(__assign({}, alert), { createdAt: new Date(alert.createdAt), updatedAt: new Date(alert.updatedAt) })); }), new Date(input.dateFrom), new Date(input.dateTo), input.groupBy);
    return alertsSummary;
};
